import React from 'react'
import { BasicAuthLayout } from '../login/BasicAuthLayout'
import { Box } from '@ztechapps/webui.util'
import { LoginOverview } from '../../../components/login-overview'

export default function LoginFailed() {
  return (
    <LoginOverview>
      <Box>
        <Box.Body>
          <BasicAuthLayout initialAlertMessage="Invalid username or password." alertType="danger" />
        </Box.Body>
      </Box>
    </LoginOverview>
  )
}
